<template>
  <div :class="headerClass" v-if="chart">
    <div class="form-group row">
      <div class="dropdown">
        <!-- DROPDOWN MENU FOR DOWNLOAD OPTIONS -->
        <button
          class="btn btn-chart btn-very-sm dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          v-tooltip="{ content: $t('chart.download_data'), placement: 'top-center' }"
        >
          <i class="fas fa-download"></i>
        </button>
        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <a class="dropdown-item" @click="downloadChartData()">Fichier CSV</a>
          <a
            class="dropdown-item"
            @click="exportChartPNG()"
            href="#"
            v-if="chart.type != 'indicator'"
            >Image PNG</a
          >
          <a
            class="dropdown-item"
            @click="exportChartSVG()"
            href="#"
            v-if="chart.type != 'indicator'"
            >Image SVG</a
          >
        </div>
      </div>

      <!-- CHART SETTINGS BUTTON -->
      <button
        v-if="
          chart.type != 'battery_lifetime' &&
            chart.type != 'battery_temperature' &&
            chart.type != 'rotation_gradient' &&
            chart.type != 'map'
        "
        type="button "
        class="btn btn-chart ml-2 btn-very-sm"
        data-toggle="modal"
        data-target="#configModal"
        @click="showChartModal"
        :data-chart-id="chart.id"
      >
        <i class="fa fa-cog fa-lg" :data-chart-id="chart.id"></i>
      </button>
    </div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import json2csv from 'json2csv'
import saveSvgAsPng from 'save-svg-as-png'
import { setTimeout } from 'timers'
import moment from 'moment'

const Json2csvParser = json2csv.Parser

export default {
  name: 'ChartConfigMenu',
  data() {
    return {
      css: `
      g {
        font-family: 'Noto Sans', 'Avenir', Helvetica, Arial, sans-serif;
      }

      .chart-axis text {
        fill: "#000";
      }

      .chart-time-axis text {
        fill: "#000";
      }

      .weekend-rect {
        opacity: 0.15;
      }

      .legend-text text {
        fill: #000 !important;
      }

      .tick text {
        fill: "#000";
      }

      .title {
        fill: "#000";
      }

      .line {
        stroke: "#000";
        fill: none;
        stroke-width: 2px;
      }

      .legend text {
        fill: "#000" !important;
      }

      g .tick line {
        opacity: 0.2;
      }

      .overlay {
        fill: none;
        pointer-events: all;
      }

      .arc text {
        font: 10px sans-serif;
        text-anchor: middle;
      }

      .arc path {
        stroke: #eee;
      }

      .background-map {
        fill: #2E4A57;
      }

      .background {
        fill: #6D7B8D;
      }

      .wall {
        fill: #272B32;
      }

      .wall-alt {
        fill: #363A40;
      }

      .path {
        fill: #A6A892;
      }

      .path-alt {
        fill: #999B84;
      }

      .visited-indoor {
        fill: #409A6C
      }

      .visited-indoor-alt {
        fill: #409A6C
      }

      .visited-outdoor {
        fill: #85D1AC
      }

      .visited-outdoor-alt {
        fill: #72BF9A
      }

      .underground {
        fill: #595242;
      }

      .underground-alt {
        fill: #514A3A;
      }

      .visitable-indoor {
        fill:#7490A7;
      }

      .visitable-indoor-alt {
        fill: #658299;
      }

      .visitable-outdoor {
        fill: #92ADC4;
      }

      .visitable-outdoor-alt {
        fill: #8AA1B4;
      }

      .alarm-outdoor {
        fill: #AE9DA4;
      }

      .alarm-outdoor-alt {
        fill: #AA8B91;
      }

      .alarm-indoor {
        fill: #8A6268;
      }

      .alarm-indoor-alt {
        fill: #7C535A;
      }

      .closed-indoor {
        fill: #4A4E54;
      }

      .closed-indoor-alt {
        fill: #5A5E64;
      }

      .closed-outdoor {
        fill: #979BA2;
      }

      .closed-outdoor-alt {
        fill: #8D9197;
      }

      .water {
        fill: #8C9AA4;
      }

      .water-alt {
        fill: #8194A0;
      }

      .grass {
        fill: #76938B;
      }

      .grass-alt {
        fill: #64897C;
      }

      .silhouette {
        fill: #616F83;
      }

      .silhouette-alt {
        fill: #616F83;
      }`,
      selectedSVG: null,
      allRemovedSVG: [],
    }
  },
  props: ['chart', 'chartsData'],
  mounted() {},
  computed: {
    headerClass: function() {
      return this.chart.type !== 'map' ? 'chart-config-menu' : 'chart-map-config-menu'
    },
  },
  methods: {
    showChartModal: function(event) {
      this.$emit('showModal', event)
    },
    downloadChartData: function() {
      var chartData = this.chart.id
        ? this.chartsData[this.chart.id]
        : this.chartsData[this.chart.type]

      if (this.chart.type == 'time') {
        chartData = chartData.items
        if (this.chart.sort_by != 'all') {
          chartData = Array.from(chartData, i => {
            var item = {}
            item[this.$t('date')] = moment(i.date, 'YYYY-MM-DD').format(this.dateFormat)
            for (var key in i[this.chart.sort_by]) {
              if (
                this.chart.sort_by == 'site_id' ||
                this.chart.sort_by == 'language' ||
                this.chart.sort_by == 'product'
              ) {
                item[this.$t(this.chart.sort_by + '.' + String(key))] = i[this.chart.sort_by][key]
              } else {
                item[key] = i[this.chart.sort_by][key]
              }
            }
            return item
          })
        } else {
          chartData = Array.from(chartData, c => {
            var item = {}
            ;(item[this.$t('date')] = moment(c.date, 'YYYY-MM-DD').format(this.dateFormat)),
              (item[this.$t('value')] = c.value),
              (item['type'] = this.$t('chart.data_type.' + this.chart.data_type))
            return item
          })
        }
      } else if (this.chart.type == 'indicator') {
        var item = {}
        if (this.chart.sort_by != 'all' && this.chart.sort_by != '') {
          item['Type'] = this.$t('chart.data_type.' + this.chart.data_type)
          for (var key in chartData[this.chart.sort_by]) {
            if (
              this.chart.sort_by == 'site_id' ||
              this.chart.sort_by == 'language' ||
              this.chart.sort_by == 'product'
            ) {
              item[this.$t(this.chart.sort_by + '.' + String(key))] =
                chartData[this.chart.sort_by][key]
            } else {
              item[key] = chartData[this.chart.sort_by][key]
            }
          }
        } else {
          item[this.$t('value')] = chartData.value
          item['Type'] = this.$t('chart.data_type.' + this.chart.data_type)
        }
        chartData = [item]
      } else if (this.chart.type == 'day') {
        chartData = chartData.items
        chartData = Array.from(chartData, c => {
          var item = {}
          ;(item[this.$t('visiting_time')] = c.date),
            (item[this.$t('start')] = c.value.start),
            (item[this.$t('end')] = c.value.end),
            (item[this.$t('affluence')] = c.affluence)
          return item
        })
      } else if (this.chart.type == 'bar' || this.chart.type == 'pie') {
        chartData = chartData.items
        chartData = Array.from(chartData, c => {
          var item = {}
          item[this.$t('filter.' + this.chart.distribution_type)] =
            typeof c.category == 'string' && this.chart.distribution_type != 'duration'
              ? this.$t(this.chart.distribution_type + '.' + String(c.category))
              : c.category
          item[this.$t('chart.data_type.count')] = c.count
          item[this.$t('chart.data_type.percentage')] = c.percent
          return item
        })
      } else if (this.chart.type == 'battery') {
        chartData = chartData.levels
        chartData = Array.from(chartData, c => {
          var item = {}
          item[this.$t('session.id')] = c.session_id
          item[this.$t('device_placeholder')] = c.device_serial
          item[this.$t('date')] = moment(c.start_time).format(this.dateFormat)
          item[this.$t('battery.level')] = JSON.stringify(c.battery_lifetime)
          return item
        })
      } else if (this.chart.type == 'rotation') {
        chartData = chartData.items
        chartData = Array.from(chartData, c => {
          var item = {}
          item[this.$t('device_placeholder')] = c.category
          item[this.$t('chart.data_type.count')] = c.count
          item['Type'] = this.$t('chart.data_type.' + this.chart.data_type)
          return item
        })
      } else if (
        this.chart.type == 'battery_lifetime' ||
        this.chart.type == 'battery_temperature'
      ) {
        chartData = chartData.items
        chartData = Array.from(chartData, c => {
          var item = {}
          item[this.$t('session.id')] = c.session_id
          item[this.$t('device_placeholder')] = c.device_serial
          item[this.$t('battery.level')] = JSON.stringify(c.values)
          return item
        })
      } else if (this.chart.type == 'rotation_gradient') {
        chartData = chartData.items
        chartData = Array.from(chartData, c => {
          var item = {}
          item[this.$t('device_placeholder')] = c.device_serial
          item[this.$t('data_type.percentage')] = '-' + String(c.percent)
          return item
        })
      } else if (this.chart.type == 'map') {
        chartData = chartData.routes
        chartData = Array.from(chartData, c => {
          var item = {}
          item['area_id'] = c.area_name
          // item['area_name'] = this.$t('map_areas.' + this.chartsData.map.site_id + '.' + c.raw_area_name)
          item['area_name'] = this.$i18n.messages[this.$i18n.locale].map_areas[
            this.chartsData.map.site_id
          ][c.raw_area_name]
          item['value'] = c.value
          item['unit'] = this.chartsData.map.unit
          return item
        })
      } else if (this.chart.type == 'matrix') {
        let columns = chartData.columns
        chartData = chartData.items

        let dataValueRows = ['affluence', 'start', 'end']

        let chartDataTemp = []

        chartData.forEach(c => {
          dataValueRows.forEach(dataValue => {
            let item = {}
            item[this.$t('date')] = moment(c.date, 'YYYY-MM-DD').format(this.dateFormat)

            item[this.$t('value')] = this.$t(dataValue)

            columns.forEach(col => {
              let found = c.value.find(val => {
                return val.time == col
              })
              item[col] = found ? found[dataValue] : 0
            })

            chartDataTemp.push(item)
          })
        })

        chartData = chartDataTemp
      }

      const parser = new Json2csvParser()
      const csvData = parser.parse(chartData)

      const url = window.URL.createObjectURL(new Blob([csvData]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `export_chart_data_${this.chart.id}_${moment().format('YYYYMMDD_HH:mm:ss')}.csv`,
      )
      document.body.appendChild(link)
      link.click()
    },
    exportChartPNG: async function() {
      try {
        await this.prepareSVGElement()
        const uri = await saveSvgAsPng.svgAsPngUri(
          document.getElementById(
            this.chart.id
              ? `svg-${this.chart.type}chart${this.chart.id}`
              : `svg-${this.chart.type}chart`,
          ),
          {
            encoderOptions: 1.0,
          },
        )

        this.processDownloadLink(uri, 'png')
      } catch (error) {
        console.error('Error when processing PNG:', error)
      }
    },
    exportChartSVG: async function() {
      await this.prepareSVGElement()
      var source = new XMLSerializer().serializeToString(this.selectedSVG.node())

      setTimeout(() => {
        var doctype =
          '<?xml version="1.0" standalone="no"?>' +
          '<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">'

        var blob = new Blob([doctype + source], {
          type: 'image/svg+xml;charset=utf-8',
        })
        var uri = window.URL.createObjectURL(blob)

        this.processDownloadLink(uri, 'svg')
      }, 500)
    },
    prepareSVGElement: async function() {
      this.selectedSVG = d3.select(
        this.chart.id
          ? `#svg-${this.chart.type}chart${this.chart.id}`
          : `#svg-${this.chart.type}chart`,
      )

      //Apply new style to the SVG to download for better readability
      this.selectedSVG.attr('class', 'svg-download')

      this.allRemovedSVG = []

      if (this.chart.type == 'map') {
        let levelsSVG = this.selectSVGElements('level')
        levelsSVG.forEach(levelSVG => {
          if (levelSVG.attr('id').split('_')[1] != this.chart.selected_level) {
            this.allRemovedSVG.push(levelSVG)
            levelSVG.remove()
          }
        })
      }

      //Remove < and > characters

      //Add chart's subtitles
      if (
        document.getElementById('input-start-date') &&
        document.getElementById('input-end-date')
      ) {
        var subTitlePeriod = `${this.$t('chart.over_period', [
          document.getElementById('input-start-date').value,
          document.getElementById('input-end-date').value,
        ])}`
      }

      let subTitleFilters = ''

      if (this.chart.filters && this.chart.filters.length > 0) {
        this.chart.filters.forEach((filter, index, arr) => {
          subTitleFilters += `${this.$t('filter.' + filter.type)} : `
          if (filter.values.length > 1) {
            var values = filter.values.map(value => {
              return typeof value == 'string' ? this.$t(filter.type + '.' + value) : value
            })
            subTitleFilters += values.join()
          } else {
            subTitleFilters +=
              typeof filter.values[0] == 'string'
                ? this.$t(filter.type + '.' + filter.values[0])
                : filter.values[0]
          }
          if (index < arr.length - 1) {
            subTitleFilters += ' - '
          }
        })
      }

      //Resize svg with his new subtitles
      let size = this.selectedSVG
        .attr('viewBox')
        .split(' ')
        .slice(2)
      let newSize = new Array(2)
      newSize[0] = Number(size[0])
      newSize[1] = Number(size[1])
      //if (subTitleFilters != '' || this.chart.type == 'map') {
      newSize[1] += 60
      this.selectedSVG.attr('viewBox', '0 0 ' + newSize[0] + ' ' + newSize[1])
      //}

      let g = this.selectedSVG.append('g').attr('id', 'chart-legend-subtitle')
      g.append('text')
        .attr('class', 'title')
        .attr('x', newSize[0] / 2)
        .attr('y', subTitleFilters != '' ? newSize[1] - 40 : newSize[1] - 10)
        .attr('text-anchor', 'middle')
        .attr('fill', '#000')
        .text(subTitlePeriod)

      if (subTitleFilters != '') {
        g.append('text')
          .attr('class', 'title')
          .attr('x', newSize[0] / 2)
          .attr('y', newSize[1] - 15)
          .attr('text-anchor', 'middle')
          .attr('fill', '#000')
          .text(subTitleFilters)
      }

      this.selectedSVG.append('style').text(this.css)
    },
    processDownloadLink: function(uri, format) {
      const link = document.createElement('a')
      link.href = uri
      link.setAttribute(
        'download',
        `export_${this.chart.type}_${this.chart.id}_${moment().format(
          'YYYYMMDD_HH:mm:ss',
        )}.${format}`,
      )
      document.body.appendChild(link)
      link.click()

      d3.selectAll(`#svg-${this.chart.type}chart${this.chart.id} style`).remove()

      this.selectedSVG.attr('class', null)

      if (
        this.chart.type == 'map' &&
        (this.chart.site_id == '4' || this.chart.site_id == '10' || this.chart.site_id == '11')
      ) {
        //Add element
      }

      //if (this.chart.filters.length > 0) {
      var size = this.selectedSVG
        .attr('viewBox')
        .split(' ')
        .slice(2)
      size[1] = Number(size[1]) - 60
      this.selectedSVG.attr('viewBox', '0 0 ' + size[0] + ' ' + size[1])
      //}
    },
    selectSVGElements: function(prefixID) {
      //Return SVG nodes according to his prefix ID
      let selectedEls = []
      d3.selectAll('#mapSVG g').each(function() {
        var el = d3.select(this)
        if (el && String(el.attr('id')).startsWith(prefixID)) {
          selectedEls.push(el)
        }
      })
      return selectedEls
    },
  },
}
</script>

<style>
.chart-config-menu {
  position: absolute;
  top: 0.5em;
  right: 2.4em;
}

.chart-map-config-menu {
  position: absolute;
  bottom: 0.5em;
  right: 2.4em;
}

.export-chart-background {
  background: white;
}
</style>
